import { styled } from '@mui/material/styles';
import { Select } from '@mui/material';

const CssSelect = styled(Select)({
    // Fieldset label on focus
    '& label.Mui-focused': {
        color: '#9c8c71',
    },
    
    '&.MuiOutlinedInput-root': {
        // Fieldset box color
        '& fieldset': {
            borderColor: '#9c8c71',
            color: 'black'
        },

        // Fieldset box on hover
        '&:hover fieldset': {
            borderColor: '#8B7A5F',
        },

        // Fieldset box on focus
        '&.Mui-focused fieldset': {
            borderColor: '#9c8c71',
        },
    }
});

export default CssSelect;
